/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NumberFilterComponent} from './number-filter.component';
import {InputModule} from '../../input/input.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {FilterFooterModule} from '../filter-footer/filter-footer.module';
import {TooltipModule} from '../../tooltip/tooltip.module';

@NgModule({
    declarations: [NumberFilterComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        ReactiveFormsModule,
        TooltipModule,
        FilterFooterModule,
        InputModule
    ],
    exports: [NumberFilterComponent]
})
export class NumberFilterModule {
}
